var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#AF2828",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2384_6213)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00014 3.42859C8.31573 3.42859 8.57157 3.68443 8.57157 4.00002V7.42859C8.57157 7.74418 8.31573 8.00002 8.00014 8.00002C7.68455 8.00002 7.42871 7.74418 7.42871 7.42859V4.00002C7.42871 3.68443 7.68455 3.42859 8.00014 3.42859Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85742 10.8571C6.85742 10.2259 7.3691 9.71423 8.00028 9.71423C8.63146 9.71423 9.14314 10.2259 9.14314 10.8571C9.14314 11.4883 8.63146 11.9999 8.00028 11.9999C7.3691 11.9999 6.85742 11.4883 6.85742 10.8571Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33273 7.53937C1.07833 7.79377 1.07833 8.20623 1.33273 8.46063L7.53911 14.667C7.79351 14.9214 8.20597 14.9214 8.46037 14.667L14.6667 8.46063C14.9211 8.20623 14.9211 7.79377 14.6667 7.53937L8.46037 1.33299C8.20597 1.07859 7.79351 1.0786 7.53911 1.33299L1.33273 7.53937ZM0.524611 9.26875C-0.176101 8.56804 -0.176101 7.43196 0.524611 6.73125L6.73099 0.524872C7.4317 -0.17584 8.56778 -0.17584 9.26849 0.524871L15.4749 6.73125C16.1756 7.43196 16.1756 8.56804 15.4749 9.26875L9.26849 15.4751C8.56778 16.1758 7.4317 16.1758 6.73099 15.4751L0.524611 9.26875Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2384_6213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7c954fc883c8d8527f8a6704102c3d0c.svg";
export { ForwardRef as ReactComponent };